import { Route, Routes } from "react-router-dom";

import Labels from "./Labels";
import LinkedInAccounts from "./LinkedInAccounts";
import Proxies from "./Proxies";

export default function Accounts() {
  return (
    <Routes>
      <Route path="/labels" element={<Labels />} />
      <Route path="/proxies" element={<Proxies />} />
      <Route path="/*" element={<LinkedInAccounts />} />
    </Routes>
  );
}
